module.exports = __webpack_public_path__ + "img/16581276_L.476c6432.png";